const getForwarderInputsTableElements = () => {
  const tableLayout = {
    entityTableId: "forwarder-inputs",
    defaultPageSize: 50,
    defaultSort: { attributeId: "title", direction: "asc" },
    defaultDisplayedAttributes: [
      "title",
      "type",
      "input_profile_id",
      "forwarder_title",
      "forwarder_status",
      "forwarder_version",
      "input_state",
      "traffic_last_minute",
      "address",
      "port"
    ],
    defaultColumnOrder: [
      "title",
      "type",
      "input_profile_id",
      "input_state",
      "traffic_last_minute",
      "address",
      "port",
      "forwarder_title",
      "forwarder_status",
      "forwarder_version"
    ]
  };
  const additionalAttributes = [
    { id: "address", title: "Address" },
    { id: "port", title: "Port" },
    { id: "forwarder_status", title: "Forwarder status" },
    { id: "forwarder_version", title: "Forwarder Version" },
    { id: "traffic_last_minute", title: "Traffic / min" }
  ];
  return {
    tableLayout,
    additionalAttributes
  };
};
export default getForwarderInputsTableElements;
